import { DCPBadgeDTO, DCPValueUnitDTO } from '@dh-io-emh/commerce-api/src/models/shared/ocb';
import { computed } from 'vue';
import { infuse } from '../ioc-config';

export const usePowerFootnote = ({
  electricPower,
  combustionPower,
}: {
  electricPower: DCPValueUnitDTO;
  combustionPower: DCPValueUnitDTO;
}) =>
  computed(() => {
    const showHybridPowerFootnote = infuse('config')?.footnotes?.showHybridPowerFootnote;

    return showHybridPowerFootnote && electricPower?.value && combustionPower?.value;
  });

export const usePriceBadgeFootnote = (badges: DCPBadgeDTO[]) =>
  computed(() => {
    const showMainPriceBadgeFootnote = infuse('config')?.footnotes?.showMainPriceBadgeFootnote;

    return showMainPriceBadgeFootnote && badges && badges.length >= 1 && badges[0].footnote;
  });
